import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { useEffect, useMemo, useRef } from 'react'
import css from 'classnames'
import { useStore } from '~/app/store'

import { Card, Tabs } from '~/shared/ui'
import { TableContainer } from '~/shared/ui/table'
import { Input } from '~/shared/ui/input'
import GoToTop from '~/features/scroll-to-top'
import { createRoleColumns } from '~/features/role-add/config'

export const RoleEdit = observer(() => {
  const { t } = useTranslation(['common', 'roles'])
  const { usersStore } = useStore()
  const {
    validationErrors,
    setEditRole,
    roleById,
    permissions,
    isLoading,
    loaders,
    getRoleById,
  } = usersStore
  const listBottom = useRef<HTMLDivElement>(null)
  const anchor = useMemo(
    () => <div ref={listBottom} className={css({ hidden: isLoading })} />,
    [isLoading],
  )
  const params = useParams()

  useEffect(() => {
    getRoleById(params.id as string)
  }, [params.id, getRoleById])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditRole(e.target.value)
  }
  const permissionsData = permissions || []
  const tabsHeader = permissionsData.map((section) => ({
    id: section.key,
    label: section.displayName,
  }))
  const tabsContent = permissionsData.map((section) => ({
    id: section.key,
    element: (
      <div className="w-full border border-[#E0E0E0] rounded-t-xl rounded-b-md">
        <TableContainer
          columns={createRoleColumns(
            section.groups.flatMap((group) => group.permissions),
          )}
          data={section.groups.map((group) => ({
            name: group.displayName,
            permissions: group.permissions,
          }))}
          variantRow="medium"
          isLoading={loaders.permissions}
          className="w-full"
        />
      </div>
    ),
  }))

  return (
    <div>
      {!isLoading && roleById && (
        <Card className="flex w-[100%] flex-col gap-3">
          <p className="text-[20px] text-[#242424]">{t('roles:roleInfo')}</p>

          <Input
            className="rounded"
            label={t('roles:roleName')}
            value={roleById?.name}
            onChange={handleChange}
            labelType="floating"
            helperText={validationErrors['user.name']}
            status={validationErrors['user.name'] ? 'error' : undefined}
          />

          <div />
          <p className="text-[20px] text-[#242424]">{t('roles:permissions')}</p>
          <Tabs
            tabsType="contained"
            tabsHeader={tabsHeader}
            tabsContent={tabsContent}
          />
          {anchor}
          <GoToTop />
        </Card>
      )}
      {!isLoading && !roleById && t('roles:roleNotFound')}
    </div>
  )
})
